import React, { useEffect } from "react";
import "./CaseStudiesMain2.css";
import { casestudiesContent } from "../../Data/CaseStudiesData";
import { useLocation } from "react-router-dom";
import NavComponent from "../../components/NavComponent";
import SEOHelmet from "../../components/SEOHelmet";

export const CaseStudiesMain2 = () => {
  const location = useLocation();
  const { state } = location;
  const caseStudiesDetails = casestudiesContent.find(
    (item, index) => item.id === state
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const overView = caseStudiesDetails.overview;
  const businessChallenges = caseStudiesDetails.businessChallenges;
  const keyCapabilities = caseStudiesDetails.keyCapabilities;
  const aboutCanvendor = caseStudiesDetails.aboutCanvendor;
  const businessImpact = caseStudiesDetails.businessImpact;

  return (
    <div className="casestudy-element" data-model-id="235:5902">
      <SEOHelmet title={caseStudiesDetails.title} />
      <NavComponent />
      <div className="casestudy-div">
        {/* Header Section */}
        <div className="casestudy-header-section">
          <h1 className="casestudy-text-wrapper-3">
            {caseStudiesDetails.title}
          </h1>

          <div className="casestudy-client-info">
            <p className="casestudy-client-confidential">
              <span className="casestudy-span">Client: </span>
              <span className="casestudy-text-wrapper-19">Confidential</span>
            </p>
            <div className="casestudy-divider"></div>
            <p className="casestudy-industry">
              <span className="casestudy-span">Industry: </span>
              <span className="casestudy-text-wrapper-20">
                {caseStudiesDetails.industry}
              </span>
            </p>
            <div className="casestudy-divider"></div>
            <p className="casestudy-solution-by">
              <span className="casestudy-span">Solution by: </span>
              <span className="casestudy-text-wrapper-20">Canvendor</span>
            </p>
          </div>
        </div>

        {/* Main Content Grid */}
        <div className="casestudy-main-content">
          <div className="casestudy-content-left">
            {/* Hero Image */}
            <img
              className="casestudy-rectangle"
              alt="Email Management Dashboard"
              src={caseStudiesDetails.image}
            />

            {/* Overview Section */}
            <div className="casestudy-overview-section casestudy-content-section">
              <div className="casestudy-section-header">
                <h2 className="casestudy-text-wrapper">Overview</h2>
                <img
                  className="casestudy-vector"
                  alt="Vector"
                  src="https://c.animaapp.com/memsjwsrCRVpSp/img/vector-8.svg"
                />
              </div>
              {overView.content && (
                <p className="casestudy-overview-text">{overView.content}</p>
              )}
              {overView.list && (
                <ul className="casestudy-overview-list-text">
                  {overView.list.map((item, index) => {
                    return <li key={index}>{item}</li>;
                  })}
                </ul>
              )}
            </div>

            {/* Business Challenges Section */}
            <div className="casestudy-challenges-section casestudy-content-section">
              <div className="casestudy-section-header">
                <h2 className="casestudy-text-wrapper-2">
                  Business Challenges
                </h2>
                <img
                  className="casestudy-img"
                  alt="Vector"
                  src="https://c.animaapp.com/memsjwsrCRVpSp/img/vector-8.svg"
                />
              </div>
              {businessChallenges.content && (
                <p className="casestudy-challenges-text">
                  {businessChallenges.content}
                </p>
              )}

              {businessChallenges.list && (
                <ul className="casestudy-challenges-list-text">
                  {businessChallenges.list.map((item, index) => {
                    return <li key={index}>{item}</li>;
                  })}
                </ul>
              )}
            </div>

            {/* Key Capabilities Section */}
            <div className="casestudy-capabilities-section casestudy-content-section">
              <div className="casestudy-section-header">
                <h2 className="casestudy-text-wrapper">Key Capabilities</h2>
                <img
                  className="casestudy-vector-2"
                  alt="Vector"
                  src="https://c.animaapp.com/memsjwsrCRVpSp/img/vector-8.svg"
                />
              </div>
              {keyCapabilities.content && (
                <p className="casestudy-capabilities-text">
                  {keyCapabilities.content}
                </p>
              )}

              {keyCapabilities.list && (
                <ul className="casestudy-capabilities-list-text">
                  {keyCapabilities.list.map((item, index) => {
                    return <li key={index}>{item}</li>;
                  })}
                </ul>
              )}
            </div>

            {/* Footer Content */}
            <div className="casestudy-footer-wrapper">
              <div className="casestudy-footer-content">
                <div className="casestudy-about-section">
                  <div className="casestudy-section-title">
                    <h2 className="casestudy-text-wrapper-2">
                      About Canvendor
                    </h2>
                    <img
                      className="casestudy-vector-3"
                      alt="Vector"
                      src="https://c.animaapp.com/memsjwsrCRVpSp/img/vector-8.svg"
                    />
                  </div>
                  {aboutCanvendor.content && (
                    <p className="casestudy-about-text">
                      {aboutCanvendor.content}
                    </p>
                  )}
                  {aboutCanvendor.list && (
                    <ul className="casestudy-about-list-text">
                      {aboutCanvendor.list.map((item, index) => {
                        return <li key={index}>{item}</li>;
                      })}
                    </ul>
                  )}
                </div>

                <div className="casestudy-footer-divider"></div>

                <div className="casestudy-impact-section">
                  <div className="casestudy-section-title">
                    <h2 className="casestudy-text-wrapper-2">
                      Business Impact
                    </h2>
                    <img
                      className="casestudy-vector-4"
                      alt="Vector"
                      src="https://c.animaapp.com/memsjwsrCRVpSp/img/vector-8.svg"
                    />
                  </div>
                  {businessImpact.content && (
                    <p className="casestudy-impact-text">
                      {businessImpact.content}
                    </p>
                  )}
                  {businessImpact.list && (
                    <ul className="casestudy-impact-list-text">
                      {businessImpact.list.map((item, index) => {
                        return <li key={index}>{item}</li>;
                      })}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="casestudy-content-right">
            {/* Contact Form */}
            <div className="casestudy-contact-form-wrapper">
              <div className="casestudy-contact-form">
                <h2 className="casestudy-form-title">Get In Touch</h2>

                <div className="casestudy-form-field">
                  <div className="casestudy-input-wrapper">
                    <p className="casestudy-input-placeholder">
                      Enter your name
                    </p>
                  </div>
                </div>

                <div className="casestudy-form-field">
                  <div className="casestudy-input-wrapper">
                    <p className="casestudy-input-placeholder">
                      Enter your email
                    </p>
                  </div>
                </div>

                <div className="casestudy-form-field">
                  <div className="casestudy-input-wrapper">
                    <p className="casestudy-input-placeholder">Subject</p>
                  </div>
                </div>

                <div className="casestudy-form-field">
                  <div className="casestudy-textarea-wrapper">
                    <p className="casestudy-input-placeholder">
                      Enter your Message
                    </p>
                  </div>
                </div>

                <div className="casestudy-submit-button">
                  <p className="casestudy-submit-text">Send Message</p>
                </div>
              </div>
            </div>

            {/* Categories Section */}
            <div className="casestudy-sidebar-section">
              <h2 className="casestudy-sidebar-title">Categories</h2>
              <div className="casestudy-categories-list">
                {[
                  "AI/ ML Solutions",
                  "Application Engineering",
                  "Cloud Solution",
                  "Digital Transformation",
                  "Enterprise Solutions",
                  "IT Consulting",
                ].map((cat, i) => (
                  <div key={i} className="casestudy-category-item">
                    <img
                      className="casestudy-chevron-icon"
                      alt="Chevron left"
                      src="https://c.animaapp.com/memsjwsrCRVpSp/img/chevron-left.svg"
                    />
                    <p className="casestudy-category-text">{cat}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Recent Posts Section */}
            <div className="casestudy-sidebar-section">
              <h2 className="casestudy-sidebar-title">Recent Post</h2>
              <div className="casestudy-recent-posts">
                {[3, 4, "", 1, 2, 5].map((num, i) => (
                  <div key={i} className="casestudy-post-item">
                    <img
                      className="casestudy-post-thumbnail"
                      alt="Post thumbnail"
                      src={`https://c.animaapp.com/memsjwsrCRVpSp/img/rectangle-11${
                        num !== "" ? `-${num}` : ""
                      }.svg`}
                    />
                    <p className="casestudy-post-title">
                      Assistant Manager –<br />
                      Finance
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Social Media Section */}
            <div className="casestudy-social-section">
              <h2 className="casestudy-sidebar-title">Connect With Us</h2>
              <div className="casestudy-social-icons">
                {[
                  { alt: "Twitter", src: "mdi-twitter.svg" },
                  { alt: "LinkedIn", src: "mdi-linkedin-1.svg" },
                  { alt: "LinkedIn", src: "mdi-linkedin.svg" },
                  { alt: "Instagram", src: "lets-icons-insta.svg" },
                ].map((icon, i) => (
                  <div key={i} className="casestudy-social-icon-wrapper">
                    <img
                      className="casestudy-social-icon"
                      alt={icon.alt}
                      src={`https://c.animaapp.com/memsjwsrCRVpSp/img/${icon.src}`}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
